var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row align-center"},[_c('div',{class:typeof _vm.$attrs.light !== undefined ? 'loader light' : 'loader dark',style:(_vm.spinnerStyle)}),_c('div',{class:_vm.slotClass},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }